import { MODAL_TYPE } from "../constants";

const { SIDE_RIGHT, CENTER, CENTER_LARGE } = MODAL_TYPE;

export const getClassnamesForModalType = modalType => ({
  center: modalType === CENTER || modalType === CENTER_LARGE,
  large: modalType === CENTER_LARGE,
  side: modalType === SIDE_RIGHT
});
